
import dashboard from './dashboard'
import client from './client'
import country from './country'
import report from './report'

export default [
  ...dashboard,
  ...client,
  ...country,
  ...report,
]
